import {z as r} from 'zod';

export const exportColumnFormatSchema = r.enum(['comma', 'separate']);

const exportTemplateColumnOptionsSchema = r.object({
    format: exportColumnFormatSchema.optional(),
});

export const exportTemplateColumnSchema = r.object({
    id: r.string(),
    options: exportTemplateColumnOptionsSchema.nullable().optional(),
});

export const exportTemplateSchema = r.object({
    id: r.number(),
    name: r.string(),
    code: r.string().nullable(),
    isSystem: r.boolean(),
    parent: r.number().nullable(),
    columns: r.array(exportTemplateColumnSchema),
    createdAt: r.string(),
    updatedAt: r.string(),
});

export const exportTemplatesListSchema = r.array(exportTemplateSchema);

const exportColumnCatalogOptionsSchema = r.object({
    fields: r
        .object({
            format: r
                .object({
                    enum: r.array(exportColumnFormatSchema),
                    default: exportColumnFormatSchema,
                    type: r.string(),
                })
                .optional(),
        })
        .optional(),
    defaults: exportTemplateColumnOptionsSchema.optional(),
});

export const exportColumnCatalogItemSchema = r.object({
    id: r.string(),
    label: r.string(),
    sheetType: r.string(),
    sheetLabel: r.string(),
    options: exportColumnCatalogOptionsSchema.nullable(),
});

export const exportColumnsCatalogSchema = r.array(exportColumnCatalogItemSchema);

export const exportConstructorLimitsSchema = r.object({
    maxUserTemplates: r.number(),
});

export const exportConstructorExportResponseSchema = r.object({});
